<script lang="ts">
    import { fade } from 'svelte/transition';
    import { Icon, Toast, ToastBody, ToastHeader } from 'sveltestrap';
    import type { Notification } from '../global';
    import { notificationsService } from '../Services';

    const dropTime = 5000;

    let notifications: Notification[] = [];

    notificationsService.notifications.onEmit(notification => {
        notifications = [...notifications, notification];
        removeTimeout(notification);
    });

    function removeTimeout(notification: Notification): void {
        setTimeout(() => removeNotification(notification), dropTime);
    }

    function removeNotification(notification: Notification) {
        notifications = notifications.filter(n => n !== notification);
    }

</script>

<style lang="scss">

    .notifications {
        position: fixed;
        z-index: 5000;
        top: 0.6rem;
        right: 0.6rem;
    }

</style>

<div class="notifications">
    {#each notifications as notification}
    <div class="bg-{notification.color}" transition:fade>
        <Toast class="m-0">
            <ToastHeader toggle={() => removeNotification(notification)}>
                {#if notification.icon}
                    <Icon name={notification.icon} />
                {/if}
                {notification.title}
            </ToastHeader>
            <ToastBody>
                {notification.message}
            </ToastBody>
        </Toast>
    </div>
    {/each}
</div>
